import {z} from '@hono/zod-openapi';

import {imageGenerationBackgroundSchema} from './ImageGenerationBackgroundSchema';
import {imageGenerationSizeSchema} from './ImageGenerationSizeSchema';
import {imageGenerationStyleSchema} from './ImageGenerationStyleSchema';

const IMAGE_GENERATION_PROMPT_MAX_LENGTH = 1000;

export const imageGenerationRequestSchema = z
  .object({
    prompt: z.string().min(1).max(IMAGE_GENERATION_PROMPT_MAX_LENGTH),
    size: imageGenerationSizeSchema,
    background: imageGenerationBackgroundSchema,
    style: imageGenerationStyleSchema,
  })
  .openapi('ImageGenerationRequest');

export type ImageGenerationRequest = z.infer<typeof imageGenerationRequestSchema>;
